module.exports = __webpack_public_path__ + "img/header-logo.bcef7e47.svg";